module.exports = __webpack_public_path__ + "static/media/strongher5.19af9438.jpg";